<template>
  <a-drawer
    width="500px"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="配置项" prop="setItem">
        <a-checkbox-group v-model="form.setItem" @change="setItemChange">
          <a-checkbox value="1">服务器信息</a-checkbox>
          <a-checkbox value="2">设备编号</a-checkbox>
          <a-checkbox value="3">二维码信息</a-checkbox>
          <a-checkbox value="4">电流占空比</a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item label="服务器域名/IP" prop="ip" v-if="show1">
        <a-input v-model="form.ip" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="服务器端口号" prop="port" v-if="show1">
        <a-input v-model="form.port" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="编号类型" prop="codeType" v-if="show2">
        <a-radio-group v-model="form.codeType">
          <a-radio :value="0">HEX</a-radio>
          <a-radio :value="1">ASCII</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="设备编号" prop="code" v-if="show2">
        <a-input v-model="form.code" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="二维码格式" prop="qrCodeFormat" v-if="show3">
        <a-radio-group v-model="form.qrCodeFormat">
          <a-radio :value="0">前缀+桩编号</a-radio>
          <a-radio :value="1">前缀+桩编号+枪编号</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="二维码内容" prop="qrCodeValue" v-if="show3">
        <a-textarea v-model="form.qrCodeValue" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="电流占空比（0-100）" prop="currentDutyCycle" v-if="show4">
        <a-input-number v-model="form.currentDutyCycle" :min="0" :max="100" :precision="0" placeholder="请输入" style="width: 100%"/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { deviceSet } from '@/api/pages/device'

export default {
  name: 'SetForm',
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      typeList: [],
      userList: [],
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      // 表单
      form: {
        id: 0,
        setItem: undefined,
        ip: undefined,
        port: undefined,
        codeType: undefined,
        code: undefined,
        qrCodeFormat: undefined,
        qrCodeValue: undefined,
        currentDutyCycle: undefined
      },
      open: false,
      rules: {
        setItem: [{ required: true, message: '请选择要下发的配置项', trigger: ['blur', 'change'] }],
        ip: [{ required: true, message: '服务器域名/IP不能为空', trigger: ['blur', 'change'] }],
        port: [{ required: true, message: '服务器端口号不能为空', trigger: ['blur', 'change'] }, { validator: this.validatePort, trigger: ['blur', 'change'] }],
        codeType: [{ required: true, message: '编号类型不能为空', trigger: ['blur', 'change'] }],
        code: [{ required: true, message: '设备编号不能为空', trigger: ['blur', 'change'] }],
        qrCodeFormat: [{ required: true, message: '二维码格式不能为空', trigger: ['blur', 'change'] }],
        qrCodeValue: [{ required: true, message: '二维码内容不能为空', trigger: ['blur', 'change'] }],
        currentDutyCycle: [{ required: true, message: '电流占空比不能为空', trigger: ['blur', 'change'] }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    validatePort (rule, value, callback) {
      if (!/^(0|[1-9]\d{0,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/.test(value)) {
        callback(new Error('请输入正确的端口号'))
      } else {
        callback()
      }
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        id: 0,
        setItem: undefined,
        ip: undefined,
        port: undefined,
        codeType: undefined,
        code: undefined,
        qrCodeFormat: undefined,
        qrCodeValue: undefined,
        currentDutyCycle: undefined
      }
    },
     /** 新增按钮操作 */
    handleSet (row) {
      this.reset()
      this.show1 = false
      this.show2 = false
      this.show3 = false
      this.show4 = false
      this.form.id = row.id
      this.open = true
      this.formTitle = '配置'
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id) {
            deviceSet(this.form).then(response => {
              this.$message.success(
                '配置已下发',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    handleChange(value) {
      console.log(`selected ${value}`)
    },
    handleBlur() {
      console.log('blur')
    },
    handleFocus() {
      console.log('focus')
    },
    filterOption(input, option) {
      return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0)
    },
    setItemChange(checkedValues) {
      this.show1 = checkedValues.includes('1')
      this.show2 = checkedValues.includes('2')
      this.show3 = checkedValues.includes('3')
      this.show4 = checkedValues.includes('4')
    }
  }
}
</script>
